<template>
    <div>
        <v-row v-if="textSearch" class="no-frame lm-border pa-3 mb-2 mt-0 pt-0">
            <v-col class="no-frame">
                <v-text-field
                    v-model="filter.text"
                    hide-details
                    @input="onSearchText"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame mr-1 lm-border pa-3 pt-1 pb-1">
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "Liftmanagement"
                            v-model = "filter.lim"
                            class   = "mt-0 pr-2"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                            style="width: 150px;"
                        />
                        <c-tag
                            class="mt-2"
                            label="LIM"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   ="DLS"
                            v-model = "filter.dls"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            style="width: 150px;"
                            hide-details
                        />
                        <c-tag
                            class="mt-2"
                            label="DLS"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame" v-if="showMisc">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "Projekt"
                            v-model = "filter.misc"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            style   = "width: 150px;"
                            hide-details
                        />
                        <c-tag
                            class="mt-2"
                            label=""
                        />
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="no-frame lm-border pa-3 pt-1 pb-2 ml-1">
                <v-row class="no-frame" >
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "Meine Kunden"
                            v-model = "myCustomers"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onCustomerChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "aktiv"
                            v-model = "filter.active"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame v-flex">
                        <v-checkbox
                            label   = "inaktiv"
                            v-model = "filter.inactive"
                            class   = "mt-0"
                            :ripple = "false"
                            @change = "onChanged"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CTag from "@/modules/core/components/utils/CTag";
import Core from "@/modules/core/service/Core";
import Customer from "@/modules/msd/company/customer/service/Customer";

export default {
    name: "MCustomerFilter",
    components: {
        CTag
    },

    props: {
        textSearch: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        showMisc: {
            required: false,
            type: Boolean,
            default : function () {
                return true;
            }
        },
    },

    data: () => ({
        myCustomers: false,
        filter  : {
            text: "",
            lim: true,
            dls: true,
            misc: false,
            unref: false,
            active :true,
            inactive: false,
            rename: false
        },
        defaultFilter: {
            lim     : true,
            dls     : true,
            misc    : false,
            unref   : false,
            active  :true,
            inactive: false,
            rename  : false
        }
    }),

    watch: {
        criteria: function () {
            this.onCustomerChanged();
        }
    },

    mounted() {
        this.myCustomers = this.hasCustomerPreferences;
        this.defaultFilter.misc = this.showMisc;
        this.filter.misc = this.showMisc;

        if (this.myCustomers) {
            this.onCustomerChanged ();
        }
    },

    computed: {
        criteria () {
            return this.filter.text;
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        hasCustomerPreferences () {
            return this.preferences.customer && this.preferences.customer.length > 0;
        },
    },

    methods: {
        onCustomerChanged () {
            this.$emit("customer");
            this.$bus.$emit (this.$events.searchcustomer, {
                myCustomers: this.myCustomers,
                criteria   : this.criteria
            });
        },

        onChanged () {
            this.$emit("changed", this.filter);
        },

        onSearchText () {
             this.$emit("changed", this.filter);
        },

        filterOn () {
            return this.filter.lim !== this.defaultFilter.lim
                || this.filter.dls !== this.defaultFilter.dls
                || this.filter.misc !== this.defaultFilter.misc
                || this.filter.unref !== this.defaultFilter.unref
                || this.filter.active !== this.defaultFilter.active
                || this.filter.inactive !== this.defaultFilter.inactive
                || this.filter.rename !== this.defaultFilter.rename
                || (this.filter.text.length > 0)
                ;
        },

        clearFilter () {
            this.filter.lim = this.defaultFilter.lim;
            this.filter.dls = this.defaultFilter.dls;
            this.filter.misc = this.defaultFilter.misc;
            this.filter.unref = this.defaultFilter.unref;
            this.filter.active = this.defaultFilter.active;
            this.filter.inactive = this.defaultFilter.inactive;
            this.filter.rename = this.defaultFilter.rename;
            this.filter.text= "";
        },

        contractStatistic(item, type) {
            return Customer.contractStatistic(item, type);
        },

        match (item) {
            if (this.filter.lim) {
                const statistic = this.contractStatistic(item, 1);
                if (this.filter.active && statistic.active > 0) {
                    return this.matchText(item);
                }

                if (this.filter.inactive && statistic.inactive > 0) {
                    return this.matchText(item);
                }
            }

            if (this.filter.dls) {
                const statistic = this.contractStatistic(item, 2);
                if (this.filter.active && statistic.active > 0) {
                    return this.matchText(item);
                }

                if (this.filter.inactive && statistic.inactive > 0) {
                    return this.matchText(item);
                }
            }

            if (this.filter.misc) {
                const lim = this.contractStatistic(item, 1);
                const dls = this.contractStatistic(item, 2);

                if (lim.active === 0 && lim.inactive === 0 && dls.active === 0 && dls.inactive === 0) {
                    return this.matchText(item);
                }
            }

            if (this.filter.unref) {
                return this.matchText(item);
            }

            return false;
        },

        matchText (item) {
            return Core.filter.includes (item.name, this.filter.text);
        }
    },
}
</script>

<style scoped>

</style>